import React, { ReactNode } from 'react';
import Icon from '../../../muiComponents/Icon';

interface EmptyStateProps {
    iconName: string;
    title: string;
    description: string;
    children?: ReactNode;
}

/**
 * Centered empty state with an icon, a title, a description and optional
 * actions. Texts must already be translated.
 * @param props - Icon name, translated texts and optional action elements.
 * @returns The empty state block.
 */
const EmptyState = ({
    iconName,
    title,
    description,
    children,
}: EmptyStateProps) => (
    <div className='zitoneo-empty-state'>
        <div className='zitoneo-empty-state__icon'>
            <Icon iconName={iconName} />
        </div>
        <h3 className='zitoneo-empty-state__title'>{title}</h3>
        <p className='zitoneo-empty-state__description'>{description}</p>
        {children}
    </div>
);

export default EmptyState;
